import { isEventInPreregistration } from "./isEventInPreregistration";

export function addPasswordToLink(link, event, eventPhases) {
  const passwordParam = event.visibility === 'private' && isEventInPreregistration(eventPhases) ?
    `?pwd=${event.participants?.filters?.password}` : '';

  return `${link}${passwordParam}`
}
